import { createSlice } from "@reduxjs/toolkit";
import {
  getUser,
  setUser,
  getTenant,
  setTenant,
} from "../../utils/localStorageFunction";

const initialState = { details: getUser(), tenant: getTenant() };

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserSlice: (state, action) => {
      setUser(action.payload);
      state.details = action.payload;
    },
    resetUserSlice: (state) => {
      state.details = null;
    },
    setTenantSlice: (state, action) => {
      setTenant(action.payload);
      state.tenant = action.payload;
    },
    resetTenantSlice: (state) => {
      state.tenant = null;
    },
  },
});

export const {
  setUserSlice,
  resetUserSlice,
  setTenantSlice,
  resetTenantSlice,
} = userSlice.actions;
export default userSlice.reducer;
